import { status } from 'skin/event/status';

const dlt = (obj, form, story, data, d, action) => {
	const id = obj.row.info.at(1);
	if (!id) return status.action;
	const row = obj.row;
	row.info = [id];
	const o = {
		type: 'table',
		action: 'delete',
		table: obj.table,
		row,
	};
	action(o);
	return status.ignore;
};

export default dlt;
